<script setup name="TechnoFA" lang="ts">
import type { MachineType } from "#imports"

const props = withDefaults(
  defineProps<{
    technos: string | MachineType | MachineType[] | Record<MachineType | string, number>
    count?: boolean
    iconStyle?: string
  }>(),
  {
    count: true,
    iconStyle: "h-7 w-7",
  },
)

const { t } = useI18n()

const machineTypeCount = computed(() => {
  if (R.isPlainObject(props.technos)) {
    return props.technos
  } else {
    const machineTypes = (
      R.isArray(props.technos) ? props.technos : [props.technos]
    ) as MachineType[]
    return R.mapToObj(machineTypes, (x) => [x, R.filter(machineTypes, (e) => e === x).length])
  }
})

const displayCount = computed(
  () => (R.isArray(props.technos) || R.isPlainObject(props.technos)) && props.count,
)
</script>

<template>
  <div class="flex flex-row items-center justify-around" :class="displayCount ? 'gap-x-2' : ''">
    <div v-for="(n, techno) in machineTypeCount" :key="techno">
      <div class="flex flex-row items-center gap-x-1">
        <span v-if="displayCount" class="font-medium"> {{ n }} </span>
        <div v-tippy="t(`machine_type.${techno}`)">
          <UIcon :name="mapMachineTypeIconUrl[techno]" :class="iconStyle" />
        </div>
      </div>
    </div>
  </div>
</template>
